<template>
  <BaseEdit
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    readTitle="Relatório de Planejamento"
    width="90%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="true"
    readIcon="mdi-file-chart-outline"
  >
    <template slot="editForm">
      <ShowForm
        ref="form"
        :entry="showEntry"
        :extraData="extraData"
        :printing="printing"
        id="printableELement"
      />
    </template>

    <template slot="action1">
      <BasePrint
        printableElementId="printableELement"
        printButtonLabel="Imprimir"
        printTitle="Relatório de Planejamento de Ciclo"
        @start-printing="printing = pageLoading = true"
        @stop-printing="printing = pageLoading = false"
        :disabledPrint="false"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import ShowForm from "./planning_show_form.vue";
import BaseEdit from "@shared_components/base_edit.vue";
import BasePrint from "@shared_components/base_print.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      showEntry: null,
      formErrors: [],
      extraData: null,
      printing: false,
    };
  },
  props: {
    entry: Object,
  },
  components: {
    ShowForm: ShowForm,
    BaseEdit: BaseEdit,
    BasePrint: BasePrint,
  },
  methods: {
    loadServerEntry: function(id) {
      this.showEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_PERIOD_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.showEntry = response.data.accountContext.period;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};
const LOAD_PERIOD_QUERY = gql `
  query ($id: ID!) { 
    accountContext {
      period(id: $id) {
        id
        code
        name
        startPrediction
        startDate
        expectedEndDate
        endDate
        area
        culture {
          id
          name
        }
        varieties {
          id
          name
          title
        }
        statusText
        proratedPlanningOperations {
          id
          operationTypeId
          operationType {
            id
            name
            kind
          }
          operationDate
          observation
          activitiesAttributes {
            id
            personId
            person {
              id
              name
            }
            durationInHours
            durationInMinutes
            durationText
            patrimonyId
            patrimony {
              id
              description
            }
            implementId
            implement {
              id
              description
            }
            totalPrice
          }
          activitiesTotalPrice
          dummyExitMovementItems {
            id
            price
            unitPrice
            itemId
            item {
              id
              name
              unit {
                id
                name
              }
              brand {
                id
                name
              }
            }
            packagingId
            packaging {
              id
              name
              size
              text
            }
            storageId
            storage {
              id
              name
            }
            quantity
            hasCropLimit
            unitQuantity
          }
          dummyExitMovementItemsTotalPrice
          dummyEntryMovementItems {
            id
            itemId
            item {
              id
              name
              unit {
                id
                name
              }
            }
            packagingId
            packaging {
              id
              name
              size
              text
            }
            quantity
            storageId
            storage {
              id
              name
            }
          }
        }
        periodPlanningReport
      }
    }
  }
`;

</script>

<style scoped></style>